import React from "react";

import RandingStyle27 from "../../randing/RandingStyle27";

const privacyDetail = (
  <>
    <p><span>■ 개인정보처리방침</span></p>
    <p>
      더봄치과의원은 고객님의 개인정보를 중요시하며, 「개인정보 보호법」 및 관련 법령을 준수하고 있습니다.<br />
      본 방침을 통해 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있는지 알려드립니다.
    </p>
    <p>
      <span>1. 수집하는 개인정보 항목 및 방법</span><br />
      수집항목: 이름, 휴대전화번호, 상담 희망 내용, 서비스 이용 기록, 접속 로그<br />
      수집방법: 홈페이지 및 랜딩페이지 상담신청 양식
    </p>
    <p>
      <span>2. 개인정보의 수집 및 이용목적</span><br />
      이용목적: 상담 신청에 따른 본인 확인, 예약 안내를 위한 안내 연락(해피콜 및 문자/알림톡 발송), 맞춤형 의료 서비스 안내
    </p>
    <p>
      <span>3. 개인정보의 보유 및 이용기간</span><br />
      보유 및 이용기간: 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br />
      법령에 의한 보존: 단, 관계 법령(전자상거래 등에서의 소비자보호에 관한 법률 등)의 규정에 의하여 보전할 필요가 있는 경우 최대 3년간 보관합니다.
    </p>
    <p>
      <span>4. 개인정보의 파기절차 및 방법</span><br />
      파기절차: 목적이 달성된 후 별도의 DB로 옮겨져 일정 기간 저장된 후 파기됩니다.<br />
      파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
    </p>
    <p>
      <span>5. 개인정보 보호책임자 및 문의처</span><br />
      고객의 개인정보를 보호하고 관련 불만을 처리하기 위하여 아래와 같이 관련 부서 및 책임자를 지정하고 있습니다.<br />
      개인정보 보호책임자: 개인정보 관리 담당자<br />
      전화번호: 031-551-3322<br />
      이메일: danbi551@naver.com<br />
      주소: 강원특별자치도 춘천시 영서로 2317, 제상가동 1층 113호
    </p>
    <p>
      <span>6. 개인정보 처리 위탁</span><br />
      병원은 원활한 서비스 제공 및 시스템 관리를 위해 아래와 같이 전문업체에 업무를 위탁하고 있으며, 수탁업체가 개인정보 보호법을 준수하도록 관리·감독하고 있습니다.<br />
      data controller : (주)빅크래프트<br />
      data processor : 퍼널스(Funnels)<br />
      service related tasks : 랜딩페이지 운영
    </p>
  </>
);

function Randing487({ urlCode, urlCodeSettingId }) {
  const imageAltTexts = {
    step1:
      "춘천에 위치한 치과입니다 설문 참여하고 오스템 임플란트 38만원 혜택 받자! 0% 01 임플란트가 필요한 대상은 누구인가요? 본인 가족 혹은 지인",
    step2:
      "춘천에 위치한 치과입니다 설문 참여하고 오스템 임플란트 38만원 혜택 받자! 50% 02 성함과 연락처를 입력 해주세요",
    step3:
      "춘천에 위치한 치과입니다 설문 참여하고 오스템 임플란트 38만원 혜택 받자! 마지막 단계입니다 03 동의 시 전문상담사가 무료 상담 도와드립니다",
  };

  const stepImages = {
    step1: `${process.env.REACT_APP_CDN_BASE}/images/487/01.png`,
    step2: `${process.env.REACT_APP_CDN_BASE}/images/487/02(1).png`,
    step3: `${process.env.REACT_APP_CDN_BASE}/images/487/03.png`,
  };

  return (
    <>
      <style>{`
        .randing-style-27 .select-btn {
          border: solid 2px #000 !important;
          color: #000 !important;
        }
        .randing-style-27 .submit-btn {
          background-color: #001D63 !important;
        }
        .form-container.randing-style-27 .step3 .agreement-section .agree-item .detail-link {
          color: #001D63 !important;
        }
        .randing-style-27 .step-contents {
          bottom: 2%;
        }
        .randing-style-27 .step .step-content,
        .randing-style-27 .step2 .step-content,
        .randing-style-27 .step3 .step-content {
          bottom: 3% !important;
        }
        @media (max-width: 768px) {
          .randing-style-27 .step-image-wrapper {
            padding-bottom: 100px !important;
          }
          .randing-style-27 .step-contents {
            bottom: 0%;
          }
          .randing-style-27 .step .step-content {
            bottom: 10% !important;
          }
          .randing-style-27 .step2 .step-content {
            bottom: 13% !important;
          }
          .randing-style-27 .step3 .step-content {
            bottom: 4% !important;
          }
        }
      `}</style>
      <RandingStyle27
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        imageFolderPath={`${process.env.REACT_APP_CDN_BASE}/images/487`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/144/bluegif.gif`}
        companyName="본원"
        privacyCompanyName="더봄치과의원"
        imageExtension="png"
        imageAltTexts={imageAltTexts}
        stepImages={stepImages}
        privacyDetailContent={privacyDetail}
        showMarketing={false}
      />
    </>
  );
}

export default Randing487;
